
import UploadFile from "./components/upload.vue";
import { appConst, FormComponentBase, Component, Prop, Watch } from "@/lib";

@Component({ name: "hi-upload-file", components: { UploadFile } })
export default class HiUploadFile extends FormComponentBase {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return [];
    },
  })
  value: Array<any>;
  @Prop({ type: String, default: "list" }) type: string;
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  format: Array<string>;
  @Prop({ type: String }) accept: string;
  @Prop({ type: Boolean, default: true }) multiple: boolean;
  @Prop({ type: Boolean, default: false }) isViewOnly: boolean;
  @Prop({ type: Boolean, default: true }) isChunkEnabled: boolean;
  @Prop({ type: Boolean, default: true }) isAutoUpload: boolean;
  @Prop({ type: Number, default: 50 }) maxSize: number; //MB
  @Prop({ type: Number, default: 4 }) maxNum: number;
  @Prop({ type: String, default: "" }) annotation: string; //注释

  currentValue = [];

  @Watch("value", { immediate: true, deep: true })
  watchValue(value) {
    if (this.currentValue != value) {
      this.currentValue = value;
    }
  }

  getComponentName() {
    return this.$util.guid();
  }

  uploadSuccess(value) {
    this.handleFile(value);
  }

  removeSuccess(value) {
    this.handleFile(value);
  }

  handleFile(value) {
    let fileArray = value.map((item) => {
      return { fileId: item.fileId, uploadFileName: item.name };
    });

    this.currentValue = fileArray;
    this.$emit("input", fileArray);
    //文件上传完成、删除时触发验证
    if (this.required) {
      this.$emit("validate", this.propName);
    }
  }

  uploadRules = {
    required: true,
    type: "Array",
    validator: (rule, value, callback) => {
      let errMsg = this.L("Validate.PleaseUploadFile");
      if (!value || value.length === 0) {
        callback(new Error(errMsg));
      } else {
        callback();
      }
    },
    trigger: "change",
  };
}
